import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { supabase } from './utils/supabaseClient';

// Import your pages
import HomePage from "./pages/HomePage";
// import AuthPage from "./pages/AuthPage"; // Keeping this as a route just in case
import ResultsPage from "./pages/ResultsPage";
import ProfilePage from "./pages/ProfilePage";
import UpdatePasswordPage from "./pages/UpdatePasswordPage";
import Dashboard from "./pages/Dashboard";
import FortunePage from "./pages/FortunePage";
import DreamPage from "./pages/DreamPage";
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  // 1. The "Brain" is still here to track login status
  const [session, setSession] = useState(null);

  useEffect(() => {
    const checkSessionAndProfile = async (currentSession) => {
      if (!currentSession) {
        setSession(null);
        return;
      }

      // If we are on the update password page, do not set the global session yet.
      // This ensures the user is not "signed in" until they complete the password update.
      if (window.location.pathname === '/update-password') {
        setSession(null);
        return;
      }

      // Check if user has a profile (completed registration)
      const { data: profile } = await supabase
        .from('USER_PROFILES')
        .select('user_id')
        .eq('user_id', currentSession.user.id)
        .maybeSingle();

      if (profile) {
        setSession(currentSession);
      } else {
        // User has session but no profile (e.g. in middle of signup)
        // We treat them as not logged in for the UI
        setSession(null);
      }
    };

    // Check active session on load
    supabase.auth.getSession().then(({ data: { session } }) => {
      checkSessionAndProfile(session);
    });

    // Listen for changes (Login/Logout)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      // If user landed via verification/reset link, do not expose session yet
      if (window.location.pathname === '/update-password') {
        setSession(null);
        return;
      }

      // Additionally, during password recovery flow, keep UI logged out
      if (event === 'PASSWORD_RECOVERY') {
        setSession(null);
        return;
      }

      checkSessionAndProfile(session);
    });

    return () => subscription.unsubscribe();
  }, []);

return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* Redirect logic: If session exists (user is logged in + has profile), 
              redirect from "/" to "/dashboard". Otherwise, show HomePage.
          */}
          <Route 
            path="/" 
            element={<HomePage session={session} />} 
          />
          
          <Route path="/dashboard" element={<Dashboard session={session} />} />
          <Route path="/results" element={<ResultsPage session={session} />} />
          <Route path="/profile" element={<ProfilePage session={session} />} />
          <Route path="/dashboard" element={<Dashboard session={session} />} />
          <Route path="/fortune" element={<FortunePage session={session} />} />
          <Route path="/dream" element={<DreamPage session={session} />} />
          <Route path="/update-password" element={<UpdatePasswordPage session={session} />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;